import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchDesignation = createAsyncThunk(
  'designation/fetchDesignation',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetDesignation();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  designationList: [],
  loading: false,
  error: '',
};

const designationSlice = createSlice({
  name: 'designation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDesignation.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.designationList = action.payload;
        state.error = '';
      })
      .addCase(fetchDesignation.rejected, (state, action) => {
        state.loading = false;
        state.designationList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default designationSlice.reducer;
